// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"207":"480e364c","445":"8d243bee","446":"2f9382da","602":"aa3f956b","821":"c616a941"}[chunkId] + ".chunk.js";
};